import Vue from 'vue'
import { GenealogyPerson, GenealogyPersonSearchRequest } from "@/models/Genealogy";

export default class WikitreeGenealogyController
{
    /**
     * - id is WikiTree ID (name), Space:[Name], or Page ID (not user id).
     * - Note that gensBefore is clamped between 0-10 generations
     *   and gensAfter is clamped between 0-5 right now.
     * - We'll have to add repeat API calls (at least for WikiTree)
     *   to go beyond that limitation in one request for our users.
     */
    static async LookupPerson(
        id : string,
        gensBefore : number = 0,
        gensAfter : number = 0,
        descendantParents : boolean = false,
        ancestorChildren : boolean = false) : Promise<GenealogyPerson | null>
    {
        const http = Vue.axios;
        const response = await http.get<GenealogyPerson | null>('genealogy/wikitree/person', {
            params: { id, gensBefore, gensAfter, descendantParents, ancestorChildren }
        });
        return response.data;
    }

    static async SearchForPerson(person : GenealogyPersonSearchRequest | any)
    {
        const http = Vue.axios;
        const response = await http.post<GenealogyPerson[] | null>('genealogy/wikitree/search', person);
        return response.data;
    }
}